<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.ALI.computeInstance.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:elasticComputeCloudResourceAli:update'
          ]"
          :loading="updateLoading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:elasticComputeCloudResourceAli:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <elastic-compute-cloud-resource-search
      ref="child"
    ></elastic-compute-cloud-resource-search>
    <table-elastic-compute-cloud-resource></table-elastic-compute-cloud-resource>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import ElasticComputeCloudResourceSearch from "../ecs/ElasticComputeCloudResourceSearch";
import TableElasticComputeCloudResource from "../ecs/TableElasticComputeCloudResource";
import Export from "../../ali/Export";

export default {
  name: "ElasticComputeCloudResourceAli",
  components: {
    ElasticComputeCloudResourceSearch,
    TableElasticComputeCloudResource,
    Export
  },
  data() {
    return {
      modal_loading: false,
      updateLoading: false
    };
  },
  methods: {
    update: function() {
      this.updateLoading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          resourceManagement: 0,
          accountType: 1
        })
        .then(res => {
          this.updateLoading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIdList: this.$refs.child.accountSearchKey,
        accountName: this.$refs.child.accountName,
        instanceId: this.$refs.child.instanceId,
        instanceName: this.$refs.child.instanceName,
        publicIp: this.$refs.child.publicIp
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      //下载Excel文件
      this.$api.resourceManagement.exportAliyunInstance(exportDTO).then(res => {
        this.exportResponse(res);
      });
    },
    exportResponse: function(res) {
      let fileName = "计算实例.xls";
      let blob = new Blob([res.data], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      this.modal_loading = false;
      this.$Message.destroy();
      this.$Message.success("导出成功");
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/ecs/ElasticComputeCloudResourceAli.vue